import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import 'rxjs/add/operator/map';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-valbum',
  providers: [CommonPipe],
  templateUrl: './valbum.component.html',
  styleUrls: ['./valbum.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class ValbumComponent implements OnInit {
  galleryId = 'myLightbox';
  application = "album";
  component = '';
  compose_response: any = [];
  is_owner = false;
  rate = 0;
  media_response: any = [];
  params: any = [];
  image_paths: any = [];
  action_class: any = {};
  id = "";
  response: any = [];
  images: any = [];
  report_param: any = [];
  isLogin = false;
  btn_process = false;
  rate_readonly = false;
  page_load = true;
  pathToMedia: any = {};
  gallery_img: any = [];
  gallery_index = 0;
  customOptions = {
    loop: true,
    items: 1,
    autoplay: true,
    center: true,
    dots: false,
    autoHeight: true,
    autoWidth: true,
    smartSpeed: 1000,
    autoplayTimeout: 5000
  };
  
  sidetabs={"recent":"Recent","viewed":"Views","rated":"Popular","liked":"Liked","favorites":"Favorite"};
  constructor(public ngxSmartModalService: NgxSmartModalService, private _mail: MailService, private router: Router, private _commonPipe: CommonPipe, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }

    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.response = this._global.getVal(data, 'response', '');
            this.pathToMedia = this._global.getVal(this.response, 'pathToMedia', {});
            this.image_paths.push(this.pathToMedia);
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));
            this.images.push(this._commonPipe.transform(this.response, ['image', this.application, 'id', 'name', 'l']));
            this._global.addMetaInfo(this.response, 'view','name');
            this.report_param = {
              id: this.response.id,
              name: this.response.name
            };

            Object.entries(this.pathToMedia).forEach(([key, value]) => {
              this.gallery_img.push(value);
            });
            Object.entries(this.response['photo']).forEach(([key, value]) => {
              value = this._global.asJsonObject(value);
              let r = {
                mediaType: "photo",
                uid: key,
                id:key,
                name: value['name']
              }
              this.gallery_img.push(r);
            });
          }else{
            this.router.navigate(['']);
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
          this.router.navigate(['']);
        });
   
  }
  ngOnInit() {
  }

  showImage(obj, index) {
    console.log("index", index);
    this.media_response = [];
    this.gallery_index = index;

    console.log(" this.gallery_index", this.gallery_index);
    let p = {
      component: 'm',
      application: 'photo',
      id: obj['uid']
    };
    this._viewService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.media_response = this._global.getVal(data, 'response', '');
          this.ngxSmartModalService.getModal('albumgallery').open();
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  edit() {
    this.router.navigate(['/my/photo'], { queryParams: { 'albumid': this.id } });
  }
  albumEdit(){
    this.router.navigate(['/edit/'+this.application], { queryParams: { a:this.application,'id': this.id } });
  }


  report() {

    this.ngxSmartModalService.getModal('popupOne').open()
    let p = {
      component: 'm',
      application: 'mail'
    };
    this._mail.compose(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

}
